import moment from 'moment'
import { useReducer } from 'react'

import { importantCampaignNames } from './data'

export const initialFilterState = {
  campaigns: Object.keys(importantCampaignNames).reduce((prev, curr) => {
    return { ...prev, [curr]: true }
  }, {}),
  category: null,
  startDate: moment().add(-1, 'days'),
  endDate: moment(),
  take: 10,
  skip: 0
}

function filterReducer(state, action) {
  switch (action.type) {
    case 'updateStartDate':
      return { ...state, startDate: action.payload }

    case 'updateEndDate':
      return { ...state, endDate: action.payload }

    case 'updateCampaigns':
      return { ...state, campaigns: action.payload }

    case 'updateCategory':
      return { ...state, category: action.payload }

    case 'getMoreResults':
      return { ...state, take: state.take + 20 }

    case 'showAlreadyCategorized':
      return { ...state, category: 2 }

    case 'showNotCategorized':
      return { ...state, category: null }

    default:
      throw new Error()
  }
}

function useTrainingFilters() {
  return useReducer(filterReducer, initialFilterState)
}

export default useTrainingFilters
